// extracted by mini-css-extract-plugin
export var body = "ArticleLayout-module--body--aeb81";
export var component = "ArticleLayout-module--component--ae763";
export var desktopOnly = "ArticleLayout-module--desktopOnly--5e441";
export var fadePop = "ArticleLayout-module--fade-pop--27081";
export var growHeightIn = "ArticleLayout-module--grow-height-in--0d0e3";
export var main = "ArticleLayout-module--main--435eb";
export var removePaddingOnMobile = "ArticleLayout-module--removePaddingOnMobile--c26e3";
export var sidebar = "ArticleLayout-module--sidebar--97057";